import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { ViewMode } from "./viewMode";
import './greeting.css'
import { Link } from "react-router-dom";
import { ChildComponentRef } from './childComponent';

const Greeting = forwardRef((props, ref) => {
    const divRef = useRef<HTMLDivElement | null>(null);
    const [childComponentBrightness, setChildComponentBrightness] = useState<number>(0);
    const [childComponentFontSize, setChildComponentFontSize] = useState<number>(0);
    const [childComponentLocation, setChildComponentLocation] = useState<{x:number, y:number}>({x:0, y:0});
    const [childComponentSize, setChildComponentSize] = useState<{x:number, y:number}>({x:0, y:0});
    const [viewMode, setViewMode] = useState<ViewMode>();
    const [windowSize, setWindowSize] = useState<{width: number, height: number}>();
    const updateChildComponentBrightness = (gb: number) => setChildComponentBrightness(gb);
    const updateChildComponentFontSize = (gfs: number) => setChildComponentFontSize(gfs);
    const updateChildComponentLocation = (gl: {x:number, y:number}) => setChildComponentLocation(gl);
    const updateChildComponentSize = (gs: {x:number, y:number}) => setChildComponentSize(gs);
    const updateViewMode = (vm: ViewMode, width?: number, height?: number) => {
        setViewMode(vm);
        if (width && height) setWindowSize({width, height});
    }
    useImperativeHandle(ref, (): ChildComponentRef => ({
        name: 'Greeting', updateChildComponentBrightness, updateChildComponentLocation, updateChildComponentSize, updateChildComponentFontSize, updateViewMode, divRef
    }));

    const mobileText = "I'm Artem Verkhovskiy - Architect, Generative Artist, and Software Developer. Thanks for visiting my website! To access the full experience with all the content and features, please visit from a desktop with a capable graphic card. In the meantime, feel free to explore these links:"
    const desktopVersion = `I'm Artem Verkhovskiy - Architect, Generative Artist, and Software Developer. Thanks for visiting my website! To get the full experience, I recommend clicking the full-screen button in the upper right corner. Press the "Explore" button to dive into the website. If you're in a hurry, you can quickly access these links:`
    let greetingText = (viewMode?.size == 'desktop' && viewMode?.graphics != 'low') ? desktopVersion : mobileText;
    
    const desktopStyle: React.CSSProperties = {
        position: "fixed",
        top: `${childComponentLocation.y}px`,
        left: `${childComponentLocation.x}px`,
        transform: "translate(-50%, 0%)",
        width: `${childComponentSize.x}px`,
        height: childComponentSize.y? `${childComponentSize.y}px` : 'auto',
        padding: '0 10px',
        opacity: `${childComponentBrightness}`
    }
    const mobileStyle: React.CSSProperties = {
        position: "fixed",
        top: `${childComponentLocation.y}px`,
        left: `${childComponentLocation.x}px`,
        transform: "translate(-50%, 0%)",
        width: `${childComponentSize.x}px`,
        height: childComponentSize.y? `${childComponentSize.y}px` : 'auto',
        padding: '0 10px',
        opacity: `${childComponentBrightness}`
    }
    const greetingTextStyle: React.CSSProperties = {
        margin: 0,
        textAlign: "justify",
        color: "white",
        fontFamily: "Roboto Condensed",
        fontWeight: 400,
        fontSize: `${childComponentFontSize}px`,
    }


    return (
        <div ref={divRef} style={viewMode?.size == 'desktop'? desktopStyle : mobileStyle}>
            <p style={greetingTextStyle}>{greetingText}</p>
            <div className="links-container" style={{fontSize: `${childComponentFontSize}px`}}>
                <Link to="/about" style={{marginRight: 'auto'}}>About Me</Link>
                <Link to="/cv">CV</Link>
                <Link to="/contacts" style={{marginLeft: 'auto'}}>Contacts</Link>
            </div>
        </div>
    )
});

export default Greeting